export { default as PageObject } from "./classes/pageObject";
export * from "./constants";
export { registerRouting, registerRoutingKey, routesAndPagesMap } from "./registerRouting";
